import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivationEnd, ActivationStart, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
    selector: 'utility-bar',
    templateUrl: './utility-bar.component.html',
    styleUrls: ['./utility-bar.component.css'],
    standalone: false
})
export class UtilityBarComponent implements OnInit, OnChanges, OnDestroy {
  @Input("utilityTemplate") utilityTemplate: TemplateRef<any>;

  @ViewChild("templateContainer", {static: false}) templateContainer: ElementRef;

  public templateRef: TemplateRef<any>;
  public showUtilityBar: boolean = true;
  public utilityBarExpanded: boolean = true;

  private routerSubscription: Subject<void> = new Subject<void>()

  constructor(private router: Router, private cdr: ChangeDetectorRef) { 
    this.router.events
    .pipe(
      filter(event => event instanceof ActivationEnd),
      takeUntil(this.routerSubscription)
    )
    .subscribe(() => {
      setTimeout(() => {
        if (this.templateRef) {
          this.checkShowUtilityBar();
          this.utilityBarExpanded = true;
        }
      }, 100);
      
    }); 
  }

  ngOnDestroy(): void {
    this.routerSubscription.next();
    this.routerSubscription.complete();
  }

  ngOnChanges(): void {
    this.templateRef = this.utilityTemplate;
    setTimeout(() => {
      this.checkShowUtilityBar();
    }, 500);
  }

  ngOnInit() {
  }

  public toggleUtilityBar(): void {
    if (this.utilityBarExpanded) {
      // transitioning to hidden
      this.utilityBarExpanded = false;
      setTimeout(() => {
        this.templateContainer.nativeElement.classList.add("d-none");
      }, 400);
    } else {
      // transitioning to show
      this.templateContainer.nativeElement.classList.remove("d-none");
      setTimeout(() => {
        this.utilityBarExpanded = true;
      }, 0);
    }
  }

  private checkShowUtilityBar(): void {
    this.showUtilityBar = this.templateRef != null;
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.templateContainer && this.templateContainer.nativeElement.children.length > 0 && !this.templateContainer.nativeElement.children[0].classList.contains("hidden")) {
        this.showUtilityBar = true;
        this.templateContainer.nativeElement.classList.remove("d-none");
      } else {
        this.showUtilityBar = false;
      }
      //this.showUtilityBar = true;
    }, 0);
    
  }

}
